import { defaultHttpClient } from '../../httpClient';
import type { PostInvitationAcceptRequest } from './types';

/**
 * 초대코드 수락 (가입완료 드로어). 로그인 성공 후 호출한다.
 */
export const postInvitationAccept = ({ code }: PostInvitationAcceptRequest) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: '/api/v2/invitation/accept/',
      data: { code },
    })
    .then(result => result.data);
};
